export const FIELD_TRANSLATIONS = {
    documentation: 'documentacion',
    period: 'periodo_id',
    major: 'carrera_id',
    belate: 'tardias',
    enroll: 'inscrito',
    shifting: 'corrimiento',
    page: 'page',
    sizePerPage: 'page_size',
    name: 'nombre',
    control: 'numero_de_control',
    date: 'fecha_de_inscripcion',
    documentPending: 'tiene_documento_pendiente',
    responsible: 'inscrito_por'
}

/**
 * Indicates that a `null` value is to be sent in the API request
 * whilst avoiding conflicts regarding the use of `null` or empty
 * values throughout the App.
 */
export const USE_API_NULL_VALUE = "USE_NULL_VALUE";